import { isEmpty } from 'lodash'
import { compose, withState, withHandlers } from 'recompose'

export const fetchingState = (options = {}) => {
  const { multi = false } = options

  return compose(
    withState('fetching', 'toggleFetching', multi ? {} : false),
    withHandlers({
      fetchingWrap: ({ toggleFetching }) => async (func, key) => {
        toggleFetching(data => multi ? { ...data, [key]: true } : true)
        let result = await func()
        toggleFetching(data => multi ? { ...data, [key]: false } : false)
        return result
      }
    })
  )
}

export const formState = compose(
  withState('data', 'changeData', {}),
  withState('errors', 'pushErrors', {}),
  withHandlers({
    clearData: ({ changeData }) => () => { changeData({}) },
    changeField: ({ changeData }) => (field, value) => changeData(data => ({ ...data, [field]: value })),
    verifyForm: ({ pushErrors, data }) => (fields, initial = {}) => {
      // let errors = Form.validate(data, fields, initial)
      let errors = {}
      pushErrors(errors)
      return isEmpty(errors)
    }
  })
)



// WEBPACK FOOTER //
// ./src/helpers/hocs.js